import React from "react";
import BlogThirtyNine from "../component/BlogThirtyNine";

function BlogThirtyNineContainer() {
  return <BlogThirtyNine />;
}

export default BlogThirtyNineContainer;
